// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-pagination {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.table-pagination div:last-child {
  display: flex;
  align-items: center;
}
.table-pagination .page-size-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-pagination .page-size-selector label {
  margin-bottom: 0;
}
.table-pagination .page-size-selector label:first-child {
  margin-right: 0.8rem;
}
.table-pagination .page-size-selector label:last-child {
  margin-left: 0.8rem;
}
.table-pagination .page-size-selector input {
  min-width: 75px;
}
.table-pagination .firstpage, .table-pagination .lastpage {
  padding-bottom: 0.16rem;
  cursor: pointer;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
